module.exports = __webpack_public_path__ + "img/shot.35e0b485.png";